import { orderDetailOptionType } from "../recoil/cart";
import Axios, { Response } from "../util/Axios";

const OrderController = {
  newOrder: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/obigo/order/newOrder";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[주문 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  sendCurrentLocation: async (oParams: any): Promise<Response> => {
    try {
      let sUrl = "https://api-stg.throo.kr/screens/user/bgTrackingV2";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[주문 오류]" + oErr.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};
export default OrderController;
